import { render, staticRenderFns } from "./PrePayNotifications.vue?vue&type=template&id=0393f5a0&scoped=true&"
import script from "./PrePayNotifications.vue?vue&type=script&lang=js&"
export * from "./PrePayNotifications.vue?vue&type=script&lang=js&"
import style0 from "./PrePayNotifications.vue?vue&type=style&index=0&id=0393f5a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0393f5a0",
  null
  
)

export default component.exports